import { getAssetUrl } from '@/config/Assets'
import AudioSource from '@/webgl/audio/AudioSource'
import ILoadableAudio, { AudioAsset } from '@/webgl/audio/interfaces/ILoadableAudio'
import SubtitleFile from '@/webgl/audio/resources/SubtitleFile'
import { BytesResource, JsonResource } from '@/webgl/resources/Net'

import AudioEngine, { getAudioPath } from '../AudioEngine'

type AudioSpriteEntry = {
  start: number
  end: number
  loop: boolean
}

type AudioSpriteSheet = {
  resources: string[]
  spritemap: Record<string, AudioSpriteEntry>
}

export default class AudioSprite implements ILoadableAudio {
  sheet: AudioSpriteSheet = null

  constructor(
    readonly engine: AudioEngine,
    readonly url: string,
    readonly subtitles: string = null
  ) {}

  async load(abort: AbortSignal): Promise<AudioAsset> {
    this.sheet = await new JsonResource(this.url).load(abort)

    const audio = new BytesResource(getAssetUrl(getAudioPath(this.sheet.resources[0])))
    const buffer = await audio.load(abort)

    const source = await this.engine.context.decodeAudioData(buffer)

    if (abort.aborted) return null

    const out: AudioAsset = {}

    for (const key in this.sheet.spritemap) {
      out[key] = {
        source: new AudioSource(this.engine, {
          buffer: source,
          start: this.sheet.spritemap[key].start,
          end: this.sheet.spritemap[key].end,
        }),
      }
    }

    if (this.subtitles) {
      const subtitle = await new SubtitleFile(this.subtitles).load(abort)
      for (const key in out) {
        out[key].track = subtitle
      }
    }

    return out
  }
}
